import React from 'react';
import { SHUFFLE_ICON_PATHS } from '@/components/Icons/paths';
import type { IconComponentProps } from '@/types/components';

export const Shuffle: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {SHUFFLE_ICON_PATHS.map((path) => (
      <path key={path} d={path} fill="currentColor" />
    ))}
  </svg>
);
